import { useIntl  } from 'react-intl';
import {  Button, Form, Input  } from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons';

const LoginPage = (props) => {  

    const intl = useIntl();

    function onFinish(values) {
        props.onSubmit(values);
      };

    function onFinishFailed(errorInfo) {
        console.log('Failed:', errorInfo);
      };
    
    return (
        <div>
            <br/>
            <Form
                name="basic"
                labelCol={{
                    span: 4,
                }}            
                wrapperCol={{
                    span: 12,
                }}
                style={{
                    maxWidth: 600,
                }}
                initialValues={{
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <Form.Item
                label={intl.formatMessage({id: "Username"})}
                name="username"
                rules={[
                    {
                    required: true,
                    message: intl.formatMessage({id: 'Username_empty'}),
                    },
                ]}
                >
                <Input prefix={<UserOutlined className="site-form-item-icon" />}/>
                </Form.Item>

                <Form.Item
                label={intl.formatMessage({id: "Password"})}
                name="password"
                rules={[
                    {
                        required: true,
                        message: intl.formatMessage({id: 'Password_empty'}),
                    },
                ]}
                >
                <Input.Password prefix={<LockOutlined className="site-form-item-icon"/>}/>
                </Form.Item>

                <Form.Item
                wrapperCol={{
                    offset: 6,
                    span: 6,
                }}
                >
                <Button type="primary" htmlType="submit">
                    Submit
                </Button>
                </Form.Item>
            </Form>
        </div>
    );   
}
  
export default LoginPage;